import React from 'react';
import NavBar from './Navbar';
import Section from "./Section";
import Categories from "./Categories";
import CTA from "./CTA";
import Footer3 from "../../../pages/Pages/PageFooterLayouts/Footer3";

const Index = () => {
    return (
        <React.Fragment>
            <NavBar />
            <Section />
            <Categories />
            <CTA />
            <Footer3 />
        </React.Fragment>
    );
}

export default Index;